import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Apollo} from 'apollo-angular';
import {map} from 'rxjs/operators';

import {PATHLOGIN, jwtHelper} from '../../variables';
import {UsuarioEntity} from '../entities/usuario.entity';
import {ALLUSUARIOS, EDITUSUARIO, GETPERMISOSUSUARIO, NEWUSUARIO, USUARIO, USUARIOTIENDA} from '../queries/usuarios.query';
import {UUIDLOCALSTORAGE} from '../../../config';


@Injectable()
export class UsuarioServices {

  constructor(private http: HttpClient, private router: Router, private  apollo: Apollo) {
  }

  loguearUsuario(user) {
    return this.http.post(PATHLOGIN, user).pipe(map((res: any) => res));
  }

  getAllUser() {

    return this.apollo.query<any>({
      query: ALLUSUARIOS
    });
  }

  getTiendasUsuario(id) {
    return this.apollo.query<any>({
      query: USUARIOTIENDA,
      variables: {
        id: +id
      }
    });
  }

  getUser(id) {
    return this.apollo.query<any>({
      query: USUARIO,
      variables: {
        id: id
      }
    });
  }

  getPermiso(idUser) {
    return this.apollo.query<any>({
      query: GETPERMISOSUSUARIO,
      variables: {
        idUser: idUser
      }
    });
  }

  updateUser(user: UsuarioEntity, tiendasSelect: any[]) {

    if (user.rol.id != 5)
      user.regional = null;

    return this.apollo.mutate<any>({
      mutation: EDITUSUARIO,
      variables: {
        id: +user.id,
        username: user.username,
        nombres: user.nombres,
        apellidos: user.apellidos,
        contrasena: user.contrasena,
        rol: +user.rol.id,
        regional: user.regional,
        tiendas: tiendasSelect,
        activo: user.activo
      }
    });
  }

  createUser(user: UsuarioEntity, tiendasSelect: any[]) {

    if (user.rol.id != 5)
      user.regional = null;

    return this.apollo.mutate<any>({
      mutation: NEWUSUARIO,
      variables: {
        username: user.username,
        nombres: user.nombres,
        apellidos: user.apellidos,
        contrasena: user.contrasena,
        rol: +user.rol.id,
        regional: user.regional,
        tiendas: tiendasSelect,
        activo: user.activo
      }
    });
  }

  isLogin() {

    let token = localStorage.getItem(UUIDLOCALSTORAGE);

    if (token == null)
      return false;
    else
      return !jwtHelper.isTokenExpired(token);
  }

  logout() {
    localStorage.removeItem(UUIDLOCALSTORAGE);
    localStorage.removeItem('user');
    this.irALogin();
  }

  irALogin() {
    this.router.navigate(['/login']);
  }

  decodeToken(token) {
    return jwtHelper.decodeToken(token);
  }


  comprobarPermisos(permiso: number, us?: UsuarioEntity): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      let permisos: any = [];

      if (us == undefined) {
        // console.log(getLoginUser());
        permisos = this.getPermiso(getLoginUser()).subscribe(d => {


          permisos = d.data.permisosxUsuario;

          // console.log(permiso);
          let p = permisos.find(p => +p.id == permiso);

          // console.log(p);

          if (p == undefined) {
            // alert('No tiene permisos para acceder a esta opcion');
            resolve(false);
          } else {
            resolve(true);
          }
        });
      } else {
        permisos = us.rol.permisos;

        let p = permisos.find(p => p.id == permiso);

        if (p == undefined) {
          alert('No tiene permisos para acceder a esta opcion');
          resolve(false);
        } else {
          resolve(true);
        }
      }
    });


  }


}


export function getLoginUser() {

  let token = localStorage.getItem(UUIDLOCALSTORAGE);

  if (token == undefined)
    return 0;

  let decode = jwtHelper.decodeToken(token);


  return decode.id;
}

export function getLoginUserFull() {

  let token = localStorage.getItem(UUIDLOCALSTORAGE);

  if (token == undefined)
    return 0;


  return jwtHelper.decodeToken(token);

}
